<!--  -->
<template>
  <div class="warp">
    <div class="newTop">
      <div class="container text">
        <span>想了解互联网最新动态</span>
        <p>资讯通通告诉你，想盈利就先抢占先机</p>
      </div>
    </div>
    <div class="container">
      <div class="brak"><b>您的位置：</b>
        <router-link to="/index">网站首页</router-link><span>></span>
        <router-link to="/newList">{{active==1?'公司快讯':active==2?'产品动态':'行业动态'}}</router-link>
      </div>

      <div class="typeList">
        <span :class="active==1?'active':''" @click="changeActive(1)">公司快讯</span>
        <div class="line"></div>
        <span :class="active==2?'active':''" @click="changeActive(2)">产品动态</span>
        <div class="line"></div>
        <span :class="active==3?'active':''" @click="changeActive(3)">行业动态</span>
      </div>

      <div class="newList">
        <div class="item" v-for="(item,index) of newList" :key="index" @click="toNewProduct(item)">
          <div class="left"><img :src="url+item.image"></div>
          <div class="right">
            <span>{{item.title}}</span>
            <p>{{item.subTitle}}</p>
            <time>{{item.createTime}}</time>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNews } from "@/api/other";
export default {
  name: "",
  data() {
    return {
      active: 1,
      newList: [],
      url: "https://api.jsgtkj.com",
    };
  },
  mounted() {
    if (this.$route.params.active) {
      this.active = this.$route.params.active;
    }
    this.getNews(this.active);
  },
  methods: {
    changeActive(index) {
      this.active = index;
      this.getNews(this.active);
    },
    getNews(type) {
      getNews({ type: type }).then((res) => {
        res.forEach((item) => {
          item.createTime = item.createTime.slice(0, 10);
        });
        this.newList = res;
      });
    },
    toNewProduct(item) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$router.push({
        name: "newProduct",
        query: { id: item.id, active: this.active },
      });
    },
  },
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #fff;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 2rem;
  .newTop {
    background: url("../../assets/images/newBanner.jpg") no-repeat center top;
    background-size: 140% auto;
    height: 7rem;
    .text {
      color: #fff;
      padding-top: 1.8rem;
      padding-left: 0.3rem;
      span {
        font-size: 0.6rem;
      }
      p {
        padding-top: 0.3rem;
        font-size: 0.32rem;
      }
    }
  }
  .brak {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-top: -58px;
    padding-left: 0.3rem;
    b {
      font-weight: bold;
    }
    span {
      padding: 0 5px;
    }
  }
  .typeList {
    display: flex;
    justify-content: center;
    padding: 0.6rem 0 0.3rem;
    align-items: center;
    span {
      font-size: 0.4rem;
      width: 2.2rem;
      text-align: center;
      line-height: 0.8rem;
      color: #666;
      transition: all 0.3s;
      cursor: pointer;
      &.active {
        background-color: #262e43;
        color: #fff;
        border-radius: 3px;
      }
    }
    .line {
      width: 1px;
      height: 0.3rem;
      background-color: #ddd;
      margin: 0 0.4rem;
    }
  }
  .newList {
    padding: 0 0.3rem;
    .item {
      padding: 0.2rem;
      display: flex;
      box-shadow: 0 0 10px 1px #e9e9e9;
      margin-top: 30px;
      align-items: center;
      cursor: pointer;
      .left {
        width: 3.5rem;
        height: 2.5rem;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .right {
        flex: 1;
        padding-left: 0.3rem;
        span {
          font-size: 0.4rem;
          white-space: nowrap;
          overflow: hidden;
          display: block;
          text-overflow: ellipsis;
          height: 0.6rem;
          max-width: 6rem;
        }
        p {
          font-size: 0.36rem;
          color: #999;
          line-height: 0.6rem;
          height: 1.2rem;
          overflow: hidden;
          margin: 0.1rem 0;
        }
        time {
          padding-top: 0.1rem;
          display: block;
          font-size: 0.32rem;
          color: #999;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/new/newList.vue